import { render } from "./DForm.vue?vue&type=template&id=6cf29bfa&ts=true"
import script from "./DForm.vue?vue&type=script&lang=ts"
export * from "./DForm.vue?vue&type=script&lang=ts"

import exportComponent from "d:\\jenkins-nodes\\Atlanta\\workspace\\Atlanta-FE-Git-189PRE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__